import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivityStudentAnswers, ActivityStudentAverage, Exercise } from '@tekman/onmat/models';
import { UserService } from '@tekman/onmat/service/generic';
import { ActivitiesFacade } from '@tekman/onmat/store/teacher/activities';
import { OverviewTable } from '../../models/overview-table.model';
import { OverviewTableService } from '../../service/overview-table.service';

@Component({
  selector: 'tekman-overview-table',
  templateUrl: './overview-table.component.html',
  styleUrls: ['./overview-table.component.scss'],
})
export class OverviewTableComponent implements OnChanges {
  @Input() exercises: Exercise[];
  @Input() studentAnswers: ActivityStudentAnswers[] = [];
  @Input() studentAverages: ActivityStudentAverage;
  overviewData: OverviewTable;
  showTooltip = false;

  constructor(
    private readonly overviewTableService: OverviewTableService,
    public readonly userService: UserService,
    public readonly activitiesFacade: ActivitiesFacade
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['studentAnswers']) {
      if (this.userService.isTeacher()) {
        this.activitiesFacade.averageGrades$.subscribe(avgGrades => {
          this.overviewData = this.overviewTableService.initOverviewTable(
            this.exercises,
            changes['studentAnswers'].currentValue,
            this.studentAverages,
            avgGrades
          );
        });
      } else {
        this.overviewData = this.overviewTableService.initOverviewTable(
          this.exercises,
          changes['studentAnswers'].currentValue,
          this.studentAverages
        );
      }
    }
  }

  nextExercises(overviewData: OverviewTable): void {
    this.overviewData = this.overviewTableService.nextExercises(overviewData);
  }

  previousExercises(overviewData: OverviewTable): void {
    this.overviewData = this.overviewTableService.previousExercises(overviewData);
  }
}
